// extracted by mini-css-extract-plugin
export default {"containerOption":"uba-z","step":"vba-z","box":"wba-z","heading":"xba-z","content":"yba-z","illustration":"zba-z","instructions":"Aba-z"};